module.exports = __webpack_public_path__ + "static/5-9a00c6db837697e2fce64510e6508319.png";